import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS,
  markupDescription
} from './../utils';
import fonts from '../../../../utils/Fonts';

// List action triggers
// Action: No Documents Image Pressed
// Action: List Item Tapped
// Action: Add
// Action: Delete

const behaviourFields = [
  {
    label: 'Action: List Item Tapped',
    name: 'actionTapped',
    description: 'The action to take when a list item is tapped',
    editor: 'dropdown',
    options: [],
    function: {
      name: 'getAppActions',
      params: ['app.id']
    },
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Action: No Items Image Pressed',
    name: 'actionOnNoDocumentsImagePress',
    editor: 'dropdown',
    description: 'An action to take then the no documents image is pressed.',
    default: false,
    options: [],
    function: {
      name: 'getAppActions',
      params: ['app.id']
    },
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Action: Plus Pressed',
    name: 'actionItemAdd',
    description:
      'The action to take when the plus button is pressed at the top of the list. If no action is selected in here, then the plus button is not displayed',
    editor: 'dropdown',
    options: [],
    function: {
      name: 'getAppActions',
      params: ['app.id']
    },
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Action: Delete Pressed',
    name: 'actionItemDelete',
    description:
      'The action to take when the delete icon is pressed on a list item. If no action is selected in here, then the delete icon is not displayed',
    editor: 'dropdown',
    options: [],
    function: {
      name: 'getAppActions',
      params: ['app.id']
    },
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Display No Records Text',
    name: 'displayNoRecordsText',
    editor: 'switch',
    description: 'The text to display when there are no records.',
    default: true,
    options: [],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Sort By',
    name: 'sortField',
    editor: 'dropdown',
    description:
      'The field from the underlying record that will be used for sorting the list i tems',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'datasourceId']
    },
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Sort Direction',
    name: 'sortDirection',
    editor: 'dropdown',
    description: 'The sort direction of the records',
    default: 'asc',
    options: [
      {
        label: 'Ascending',
        value: 'asc'
      },
      { label: 'Descending', value: 'desc' }
    ],
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Maximum Items',
    name: 'maxItems',
    editor: 'number',
    description: 'Enter the maximum number of items to display or leave blank.',
    default: '',
    hidden: true,
    displayWhen: [{ field: 'source', operator: '=', value: 'records' }],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'List Item Sub-Title Max-Lines',
    name: 'listItemSubTitleNumberOfLines',
    editor: 'number',
    description: 'The maximum number of lines to display',
    default: 2,
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  }
];

const contentFields = [
  {
    label: 'Source Type',
    name: 'source',
    editor: 'dropdown',
    description: 'The data source for the list',
    default: 'static',
    options: [
      {
        label: 'Static List of Items',
        value: 'static'
      },
      {
        label: 'List of Records',
        value: 'records'
      },
      {
        label: 'Wordpress Feed',
        value: 'wordpress'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Data Binding Source',
    name: 'datasourceId',
    description:
      'Choose a data source that this element will get its data from',
    editor: 'dropdown',
    function: {
      name: 'getDynamicDataSources',
      params: ['app.id']
    },
    default: '',
    displayWhen: [
      {
        field: 'source',
        operator: '==',
        value: 'records'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Filters',
    name: 'filters',
    description:
      'Specify additional filters in a JSON array format that accepts placeholders from the content type being displayed in the list. These filters will be applied after the data source has loaded. Example: [ { "field": "something", "operator": "==", "value" : "whatever" }, { "field": "something", "operator": "==", "value" : "{fieldname}" } ] ',
    editor: 'textarea',
    lines: 5,
    default: '[]',
    displayWhen: [
      {
        field: 'source',
        operator: '==',
        value: 'records'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Rating Field',
    name: 'ratingField',
    editor: 'dropdown',
    description:
      'The field from the underlying record to display rating stars on the listing.',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Rating Count Field',
    name: 'ratingCountField',
    editor: 'dropdown',
    description:
      'The field from the underlying record to display total number of ratings',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Title Field',
    name: 'titleField',
    editor: 'dropdown',
    description:
      'The field from the underlying record that will be used for the title that appears above the list',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Checkable',
    name: 'checkable',
    editor: 'switch',
    description:
      'If true, list entries will display a tick box to the left of each entry. The tick box can be tapped to toggle a field value.',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Check Field',
    name: 'checkableField',
    editor: 'dropdown',
    description: 'Choose a field that will be controlled by the check box',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'checkable',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Checked Value',
    name: 'checkedValue',
    editor: 'textbox',
    description:
      'Enter the value to set in the underlying checkable field when a list entry is checked.',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'checkable',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Un-Checked Value',
    name: 'uncheckedValue',
    editor: 'textbox',
    description:
      'Enter the value to set in the underlying checkable field when a list entry is unchecked.',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'checkable',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Not Checked Text',
    name: 'notCheckedText',
    editor: 'textbox',
    description:
      'Enter the value to display in the checkbox when a list item is unchecked.',
    default: '',
    options: [],
    function: {},
    displayWhen: [
      {
        field: 'checkable',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Title Field Markup',
    name: 'titleFieldMarkup',
    editor: 'textbox',
    description: markupDescription,
    default: 'My New List',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'No Records Text',
    name: 'noRecordsText',
    editor: 'textbox',
    description: 'The text to display when there are no records.',
    default: 'No Records',
    options: [],
    displayWhen: [
      {
        field: 'displayNoRecordsText',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Show List Item Title',
    name: 'listItemTitleVisible',
    editor: 'boolean',
    description: 'Shows the title of each list item',
    default: true,
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'List Item Title Field',
    name: 'listItemTitleSourceField',
    editor: 'dropdown',
    description:
      'The field from the underlying record that will be used for the title of each list item',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      },
      {
        combine: 'AND',
        field: 'listItemTitleVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'List Item Title',
    name: 'listItemTitle',
    editor: 'textbox',
    description: 'A fixed title for each list item',
    default: '',
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      },
      {
        combine: 'AND',
        field: 'listItemTitleVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Show List Item Sub-Title',
    name: 'listItemSubTitleVisible',
    editor: 'boolean',
    description: 'Shows the sub-title of each list item',
    default: true,
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'List Item Sub-Title Field',
    name: 'listItemSubTitleSourceField',
    editor: 'dropdown',
    description:
      'The field from the underlying record that will be used for the sub-title for each list item',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      values: [],
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      },
      {
        combine: 'AND',
        field: 'listItemSubTitleVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'List Item Sub-Title',
    name: 'listItemSubTitle',
    editor: 'textbox',
    description: 'A fixed sub-title for each list item',
    default: '',
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      },
      {
        combine: 'AND',
        field: 'listItemSubTitleVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Wordpress Feed Url',
    name: 'wordpressUrl',
    editor: 'textbox',
    description: 'The address of the wordpress feed',
    default: '',
    displayWhen: [{ field: 'source', operator: '=', value: 'wordpress' }],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  }
];

const colorFields = [
  'backgroundColor',
  {
    label: 'Conditional Colors',
    name: 'conditionalColors',
    editor: 'textarea',
    description:
      'Setup conditional colors for list items. { "issue" : { "yes" : [ { "backgroundColor" : "green"} ], "no" : [ { "backgroundColor" : "red"} ] 	} }',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'List Border Color',
    name: 'listBorderColor',
    editor: 'color',
    description: 'The border radius of the list container',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Activity Indicator Color',
    name: 'spinnerColor',
    editor: 'color',
    description:
      'The color of the activity indicator during record processing.',
    default: '#182fa4',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Cached Image Loading Indicator Color',
    name: 'cachedImageSpinnerColor',
    editor: 'color',
    description:
      'The color of the activity indicator when a cached image is loading in a list item.',
    default: '#182fa4',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'No Records Text Color',
    name: 'noRecordsTextColor',
    editor: 'color',
    description: 'The color to use on the no records text.',
    default: '#000000',
    options: [],
    displayWhen: [
      {
        field: 'displayNoRecordsText',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'List Title Color',
    name: 'titleColor',
    editor: 'color',
    description: 'Customise the color of the list title',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'List Item Background Color',
    name: 'listItemBackgroundColor',
    editor: 'color',
    description: 'The background color of a list item',
    default: 'white',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'List Item Title Color',
    name: 'listItemTitleColor',
    editor: 'color',
    description: 'Customise the color of the list item titles',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'List Item Icon Color',
    name: 'listItemIconColor',
    editor: 'color',
    description: 'The icon color that will be used in each list item',
    default: '#000000',
    displayWhen: [
      {
        field: 'listItemIconVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'List Item Border Color',
    name: 'listItemBorderColor',
    editor: 'color',
    description: 'The border radius of a list item',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'List Item Sub-Title Color',
    name: 'listItemSubTitleColor',
    editor: 'color',
    description: 'Customise the color of the list item sub-titles',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  }
];

const fontFields = [
  {
    label: 'List Title Font',
    name: 'titleFont',
    editor: 'fontsize',
    type: 'font',
    description: 'Customise the title font for the list',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    label: 'List Title Font Family',
    name: 'titleFontFamily',
    editor: 'dropdown',
    type: 'string',
    options: [{ label: '<Not Set>', value: '' }, ...fonts],
    description: 'Customise the title font family for the list',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    label: 'List Sub-Title Font Family',
    name: 'subtitleFontFamily',
    editor: 'dropdown',
    type: 'string',
    options: [{ label: '<Not Set>', value: '' }, ...fonts],
    description: 'Customise the sub-title font family for the list',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    label: 'List Item Title Font Family',
    name: 'listItemTitleFontFamily',
    editor: 'dropdown',
    type: 'string',
    options: [{ label: '<Not Set>', value: '' }, ...fonts],
    description: 'Customise the title font family for each list item',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    label: 'List Sub-Title Font Family',
    name: 'listItemSubTitleFontFamily',
    editor: 'dropdown',
    type: 'string',
    options: [{ label: '<Not Set>', value: '' }, ...fonts],
    description: 'Customise the sub-title font family for each list item',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    label: 'List Item Title Font',
    name: 'listItemTitleFont',
    editor: 'fontsize',
    type: 'font',
    description: 'Customise the title font for each list item',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    label: 'List Item Sub-Title Font',
    name: 'listItemSubTitleFont',
    editor: 'fontsize',
    type: 'font',
    description: 'Customise the title font for each list item',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  }
];

const imageFields = [
  {
    label: 'Display No Records Image',
    name: 'displayNoRecordsImage',
    editor: 'switch',
    description: 'Whether to display an image when there are no records.',
    default: 'small',
    options: [],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Display Image Caching',
    name: 'disableImageCaching',
    editor: 'switch',
    description: 'Whether to prevent list images from being cached.',
    default: 'small',
    options: [],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'No Records Image',
    name: 'noRecordsImage',
    mediaLibraryPath: 'apps',
    mediaLibraryStoreIn: 'custom_folder',
    editor: 'imagebrowse',
    description: 'The image to display when there are no records.',
    default: 'small',
    options: [],
    displayWhen: [
      {
        field: 'displayNoRecordsImage',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Show Card Title Icon',
    name: 'listItemCardTitleIconVisible',
    editor: 'boolean',
    description:
      'Shows an icon on the right hand side of a card title. Material Icon',
    default: true,
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'List Item Card Title Icon',
    name: 'listItemCardTitleIcon',
    editor: 'icon',
    description:
      'The icon that will be used in the card title of each list item',
    default: '',
    displayWhen: [
      {
        field: 'listItemCardTitleIconVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Show List Item Icon',
    name: 'listItemIconVisible',
    editor: 'boolean',
    description: 'Shows an icon next to each item',
    default: true,
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },

  {
    label: 'List Item Icon Field',
    name: 'listItemIconSourceField',
    editor: 'dropdown',
    description:
      'The field from the underlying record that will be used for the list item icon',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      values: [],
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      },
      {
        combine: 'AND',
        field: 'listItemIconVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'List Item Icon',
    name: 'listItemIcon',
    editor: 'icon',
    description: 'The icon that will be used in each list item',
    default: '',
    displayWhen: [
      {
        field: 'listItemIconVisible',
        operator: '=',
        value: true
      },
      {
        combine: 'AND',
        field: 'listItemIconSourceField',
        operator: '=',
        value: ' '
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Show List Item Image',
    name: 'listItemImageVisible',
    editor: 'boolean',
    description: 'Shows the image in each list item',
    default: true,
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'List Item Image Field',
    name: 'listItemImageSourceField',
    editor: 'dropdown',
    description:
      'The field from the underlying record that will be used for the list item image',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      values: [],
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [
      {
        field: 'datasourceId',
        operator: 'IS_NOT_EMPTY',
        value: []
      },
      {
        combine: 'AND',
        field: 'listItemImageVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'List Item Image Circular',
    name: 'listItemImageCircular',
    editor: 'switch',
    description: 'Whether to show the list item image as circular',
    default: false,
    displayWhen: [
      {
        field: 'listItemImageVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  }
];

const layoutFields = [
  'padding',
  'margin',
  'layout',
  {
    label: 'List Border Width',
    name: 'listBorderWidth',
    editor: 'number',
    description: 'The border width of the list container',
    default: 0,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Border Radius',
    name: 'listBorderRadius',
    editor: 'number',
    description: 'The border radius of the list container',
    default: 0,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Activity Indicator Size',
    name: 'spinnerSize',
    editor: 'dropdown',
    description: 'The size of the activity indicator.',
    default: 'small',
    options: [
      { label: 'Small', value: 'small' },
      { label: 'Large', value: 'large' }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Cached Image Loading Indicator Size',
    name: 'cachedImageSpinnerSize',
    editor: 'dropdown',
    description:
      'The size of the activity indicator when a cached image is loading.',
    default: 'small',
    options: [
      { label: 'Small', value: 'small' },
      { label: 'Large', value: 'large' }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'No Records Image Width',
    name: 'noRecordsImageWidth',
    editor: 'number',
    description: 'The width of the no records image',
    default: 80,
    displayWhen: [
      {
        field: 'displayNoRecordsImage',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'No Records Image Height',
    name: 'noRecordsImageHeight',
    editor: 'number',
    description: 'The height of the no records image',
    default: 80,
    displayWhen: [
      {
        field: 'displayNoRecordsImage',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'No Records Image Border Radius',
    name: 'noRecordsImageBorderRadius',
    editor: 'number',
    description: 'The border radius of the no records image',
    default: 0,
    displayWhen: [
      {
        field: 'displayNoRecordsImage',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: '2 Column List Layout',
    name: 'twoColumnLayout',
    editor: 'boolean',
    description: 'Display the records in the list in two vertical columns',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: '2 Column Item Layout',
    name: 'twoColumnItemLayout',
    editor: 'boolean',
    description: 'Display the item data in two columns',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'First Column % Width',
    name: 'twoColumnItemLayoutFirstPercentage',
    editor: 'number',
    default: 50,
    description: 'The percentage width of the first column',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Title in Card Title',
    name: 'titleInCardTitle',
    editor: 'boolean',
    default: true,
    description:
      'Display the title in the card title as opposed to the content',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Title Alignment',
    name: 'titleAlignment',
    editor: 'alignment',
    description: 'The alignment of the title that appears above the list',
    default: '',
    options: [],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Title Padding',
    name: 'titlePadding',
    editor: 'boundary',
    description: 'The padding around the title of the list',
    default: '5 5 5 5',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Title Margin',
    name: 'titleMargin',
    editor: 'boundary',
    description: 'The margin around the title of the list',
    default: '5 5 5 5',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Height',
    name: 'listItemHeight',
    editor: 'number',
    description: 'The height of a list item',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Margin',
    name: 'listItemMargin',
    editor: 'boundary',
    description: 'The margin around a list item',
    default: '5 5 5 5',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Padding',
    name: 'listItemPadding',
    editor: 'boundary',
    description: 'The padding within a list item',
    default: '5 5 5 5',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Title Below Image',
    name: 'listItemTitleBelowImage',
    editor: 'boolean',
    description: 'Display the list item title below its image',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Title Alignment',
    name: 'listItemTitleAlignment',
    editor: 'alignment',
    description:
      'The alignment of a listitem title that appears above the list',
    default: '',
    options: [],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Title Padding',
    name: 'listItemTitlePadding',
    editor: 'boundary',
    description: 'The padding of a listitem title that appears above the list',
    default: '',
    options: [],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Icon Size',
    name: 'listItemIconSize',
    editor: 'number',
    description: 'The icon size that will be used in each list item',
    default: 12,
    displayWhen: [
      {
        field: 'listItemIconVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Icon Alignment',
    name: 'listItemIconAlignment',
    editor: 'alignment',
    description: 'The alignment of the icon next to each list item',
    default: 'justify-center',
    displayWhen: [
      {
        field: 'listItemIconVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Icon Padding',
    name: 'listItemIconPadding',
    editor: 'boundary',
    description: 'The padding of the icon next to each list item',
    default: '0 0 0 0',
    displayWhen: [
      {
        field: 'listItemIconVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Icon Margin',
    name: 'listItemIconMargin',
    editor: 'boundary',
    description: 'The padding of the icon next to each list item',
    default: '0 0 0 0',
    displayWhen: [
      {
        field: 'listItemIconVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Image Padding',
    name: 'listItemImagePadding',
    editor: 'boundary',
    description: 'The padding around a list item image',
    default: '5 5 5 5',
    displayWhen: [
      {
        field: 'listItemImageVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Image Margin',
    name: 'listItemImageMargin',
    editor: 'boundary',
    description: 'The margin around a list item image',
    default: '5 5 5 5',
    displayWhen: [
      {
        field: 'listItemImageVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Image Width',
    name: 'listItemImageWidth',
    editor: 'number',
    description: 'The width of a list item image',
    default: 80,
    displayWhen: [
      {
        field: 'listItemImageVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Image Resize Mode',
    name: 'listItemImageResizeMode',
    editor: 'dropdown',
    description: 'The resize mode of a list item image',
    options: [
      { label: 'Cover', value: 'cover' },
      { label: 'Contain', value: 'contain' }
    ],
    default: 'cover',
    displayWhen: [
      {
        field: 'listItemImageVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Image Height',
    name: 'listItemImageHeight',
    editor: 'number',
    description: 'The height of a list item image',
    default: 80,
    displayWhen: [
      {
        field: 'listItemImageVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Image Border Radius',
    name: 'listItemImageBorderRadius',
    editor: 'number',
    description: 'The border radius of a list item image',
    default: 0,
    displayWhen: [
      {
        field: 'listItemImageVisible',
        operator: '=',
        value: true
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Border Width',
    name: 'listItemBorderWidth',
    editor: 'number',
    description: 'The border width of a list item',
    default: 0,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Border Radius',
    name: 'listItemBorderRadius',
    editor: 'number',
    description: 'The border radius of a list item',
    default: 0,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Sub-Title Padding',
    name: 'listItemSubTitlePadding',
    editor: 'boundary',
    description:
      'The padding of a listitem sub-title that appears above the list',
    default: '',
    options: [],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'List Item Sub-Title Alignment',
    name: 'listItemSubTitleAlignment',
    editor: 'alignment',
    description:
      'The alignment of a listitem sub-title that appears above the list',
    default: '',
    options: [],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  }
];

const ListElementFields = {
  group: ELEMENT_GROUPS.LISTS,
  label: 'List',
  icon: 'ViewListIcon',
  description: 'Add a list of items to the screen',
  properties: [
    'opacity',
    ...behaviourFields,
    ...contentFields,
    ...colorFields,
    ...fontFields,
    ...imageFields,
    ...layoutFields
  ]
};

export default ListElementFields;
